'use strict';

class HybridTimeController {
    constructor($scope, $bridges, TaskInfoService, HybridTimeService) {
        // controller meta setup
        $scope._logIdentifier = 'HybridTimeController';
        const $logger = $bridges.logger();
        const $runtime = $bridges.runtime();
        const $auth = $bridges.authentication();

        // controller initialisation
        const candidateUUID = $auth.getUserUUID();
        const taskInfo = TaskInfoService.getTaskInfo();

        // private scope variables
        $scope.taskInfo = taskInfo;

        $scope.onButtonQuitClick = () => {
            $runtime.quit(false);
        };

        $scope.isExpired = () => HybridTimeService.isExpired();
        $scope.isBegun = () => HybridTimeService.isBegun();
        console.log('HybridTimeController', $scope.isExpired(), $scope.isBegun());
        HybridTimeService.isExpired();
    }
}

// Define injection dependencies
HybridTimeController.$inject = ['$scope', '$bridges', 'TaskInfoService', 'HybridTimeService'];

export default function registerHybridTimeController(module) {
    module.controller('HybridTimeController', HybridTimeController);
}
